import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { UserService } from '../services/user.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
    selector: 'app-fiatdepositconfirmdialog',
    templateUrl: './fiatdepositconfirmdialog.component.html',
    styleUrls: ['./fiatdepositconfirmdialog.component.css']
})
export class FiatDepositConfirmDialog {
    element: any = {};
    myForm: any = FormControl;
    feeRestrictForReject: any;
    constructor(
        public dialogRef: MatDialogRef<FiatDepositConfirmDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public adminService: AdminService,
        public userService: UserService,
        public notificationService: NotificationsService,
        public spinnerService: Ng4LoadingSpinnerService,
    ) {
        this.element = data;
        this.myForm = this.fb.group({
            tnxid: ['', [Validators.required]],
            amount: ['', [Validators.required]],
            currency: ['', [Validators.required]],
            bankName: [''],
            fee: ['', [Validators.required, this.validateNonNegativeAndFee]],
            note: ['', [Validators.required]],
        });
        this.displayConfirmData();
        this.feeRestrictForReject = this.element['status'] === 'APPROVED' ? false : true;
    }
    approveDeposit() {
        if (this.myForm.controls['fee'].value > this.myForm.controls['amount'].value) {
            return this.notificationService.error('Fee should be less than amount');
        }
        if (this.myForm.valid) {
            this.userService.csrf().subscribe(csdata => {
                this.myForm.value['_csrf'] = csdata._csrf;
                this.spinnerService.show();
                this.myForm.value['userid'] = this.element['userid'];
                this.myForm.value['_id'] = this.element['_id'];
                this.myForm.value['status'] = this.element['status'];
                this.adminService.updateDepositbyAdmin(this.myForm.value).subscribe(data => {
                    this.notificationService.success('Success', data.message, {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    });
                    // Emit the form data when closing the dialog
                    this.dialogRef.close({ success: true, data: data });
                    this.spinnerService.hide();
                }, (err) => {
                    this.notificationService.error(err.error.message);
                })
            })
        }

    }
    

    // Custom validator function to validate non-negative fee and fee <= amount.
    validateNonNegativeAndFee: ValidatorFn = (control: AbstractControl) => {
      const amountValue = control.root.get('amount') ? control.root.get('amount').value : null;
      const feeValue = control.value;
    
      if (feeValue !== null && feeValue < 0) {
        return { nonNegative: true };
      }
    
      if (amountValue !== null && feeValue !== null && feeValue > amountValue) {
        return { feeExceededAmount: true };
      }
    
      return null;
    };
    
    displayConfirmData(): void {
        this.myForm.controls["tnxid"].patchValue(this.element.tnxid);
        this.myForm.controls["amount"].patchValue(this.element.amount);
        this.myForm.controls["currency"].patchValue(this.element.currency);
        this.myForm.controls["bankName"].patchValue(this.element.bankName);
        this.myForm.controls["fee"].patchValue(this.element.fee);
        this.myForm.controls["note"].patchValue(this.element.note);
    }
}


// WEBPACK FOOTER //
// ./src/app/fiatdepositconfirmdialog/fiatdepositconfirmdialog.component.ts